import "./v1/hero.js";
import "./v3/hero.js";
import "./v4/hero.js";
// import "./parallax/hero.js";